import { VStack, Input, Button, Link } from '@chakra-ui/react'

import { FormControl } from '@/components/FormControl'

import {
  signInURL,
  signUpURL,
  forgotPasswordURL,
} from '@/features/auth/constants/links'
import { inputStyle, linkStyle } from '@/features/auth/constants/styles'

import { t } from '@/lib/helpers'
import { getAuthenticityToken } from '@/lib/api'

type Props = {
  formActionPath: string
}

function ResendConfirmationForm({ formActionPath }: Props): React.ReactElement {
  const authenticityToken = getAuthenticityToken()

  return (
    <VStack
      spacing="4"
      sx={{
        alignItems: 'stretch',
      }}
    >
      <form
        id="new_user"
        action={formActionPath}
        acceptCharset="UTF-8"
        method="post"
      >
        <VStack
          spacing="4"
          sx={{
            alignItems: 'stretch',
          }}
        >
          <FormControl label={t('activerecord.attributes.user.email')}>
            <Input
              isRequired
              id="user_email"
              type="email"
              autoComplete="email"
              autoFocus
              name="user[email]"
              placeholder="example@cookiewow.com"
              sx={inputStyle}
            />
          </FormControl>

          <Input
            value={authenticityToken}
            type="hidden"
            name="authenticity_token"
          />

          <Button
            type="submit"
            name="commit"
            size="xl"
            value={t(
              'devise.confirmations.new.resend_confirmation_instructions',
            )}
            data-disable-with={t(
              'devise.confirmations.new.resend_confirmation_instructions',
            )}
          >
            {t('devise.confirmations.new.resend_confirmation_instructions')}
          </Button>
        </VStack>
      </form>
      <VStack
        spacing="3"
        sx={{
          alignItems: 'flex-start',
        }}
      >
        <Link href={signInURL} sx={linkStyle}>
          {t('devise.sessions.new.sign_in')}
        </Link>
        <Link href={signUpURL} sx={linkStyle}>
          {t('devise.registrations.new.sign_up')}
        </Link>
        <Link href={forgotPasswordURL} sx={linkStyle}>
          {t('devise.passwords.new.forgot_your_password')}
        </Link>
      </VStack>
    </VStack>
  )
}

export default ResendConfirmationForm
